import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={21}
      height={20}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M18.299 7.362a.35.35 0 00-.323-.037l-7.87 3.08v9.413a.346.346 0 00.127-.024l7.555-2.956c.402-.158.662-.539.662-.971V7.649a.348.348 0 00-.151-.287z"
        fill="#FFA000"
      />
      <Path
        d="M2.237 7.325a.347.347 0 00-.474.324v8.218c0 .432.26.813.663.971l7.554 2.956c.041.016.084.024.127.024v-9.413l-7.87-3.08z"
        fill="#FFB300"
      />
      <Path
        d="M18.176 7.31l-7.85-1.707a1.052 1.052 0 00-.442 0L2.035 7.309c-.15.033 8.07 3.122 8.07 3.122s8.221-3.089 8.071-3.122z"
        fill="#C47218"
      />
      <Path
        d="M20.064 10.242L18.4 7.47a.348.348 0 00-.425-.145l-7.87 3.08-7.87-3.08a.348.348 0 00-.425.145L.148 10.242c-.335.529-.074 1.293.515 1.507l6.683 2.616a1.042 1.042 0 001.274-.435l1.486-2.476 1.486 2.476c.263.442.808.62 1.274.435l6.683-2.616c.59-.213.85-.978.515-1.507z"
        fill="#FFCA28"
      />
      <Path
        d="M10.106 9.04a4.52 4.52 0 100-9.04 4.52 4.52 0 000 9.04z"
        fill="#E53935"
      />
      <Path
        d="M11.58 4.52l.738-.738a.696.696 0 000-.983l-.492-.492a.696.696 0 00-.983 0l-.737.738-.738-.738a.696.696 0 00-.983 0l-.492.492a.696.696 0 000 .983l.737.738-.737.737a.696.696 0 000 .984l.492.492a.696.696 0 00.983 0l.738-.738.737.738a.696.696 0 00.983 0l.492-.492a.696.696 0 000-.984l-.737-.737z"
        fill="#E0E0E0"
      />
    </Svg>
  );
}

export default SvgComponent;
